/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import { UserService } from '../../../services';
import { Constants } from "../../../utils";

export const SelectOwner = ({ value, displayName, onSelect, placeholder }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const wrapperRef = useRef(null);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (value && displayName) {
      setQuery(displayName);
    } else if (!value) {
      setQuery('');
    }
  }, [value, displayName]);

  const searchUsers = async (search) => {
    if (!search.trim()) {
      setResults([]);
      return;
    }
    setIsSearching(true);
    try {
      const response = await UserService.admin.findAll({ search, level_id: Constants.LEVELS.OWNER });
      setResults(response.data || []);
    } catch (error) {
      setResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleInputChange = (e) => {
    const q = e.target.value;
    setQuery(q);
    setIsOpen(true);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => searchUsers(q), 300);
  };

  const handleSelect = (user) => {
    const name = `${user?.person?.name} ${user?.person?.lastname || ''}`.trim();
    setQuery(name);
    setIsOpen(false);
    onSelect(user.id, name, user);
  };

  const handleClear = () => {
    setQuery('');
    onSelect('', '');
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={wrapperRef}>
      <div className="flex items-center gap-x-4 border border-gray6 bg-white h-10 w-full rounded-full px-5 py-3">
        <input
          type="text"
          className="flex-1 outline-none border-none bg-transparent w-full text-sm"
          placeholder={placeholder || 'Buscar propietario...'}
          value={query}
          onChange={handleInputChange}
          onFocus={() => { if (results.length || query) setIsOpen(true); }}
        />
        {!!value && (
          <button type="button" onClick={handleClear} className="p-0.5 rounded-full hover:bg-gray5 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-text">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
      {isOpen && (results.length > 0 || isSearching) && (
        <div className="absolute z-20 mt-1 w-full bg-white border border-gray6 rounded-xl shadow-lg max-h-48 overflow-y-auto">
          {isSearching ? (
            <div className="px-4 py-3 text-sm text-default">Buscando...</div>
          ) : (
            results.map(user => (
              <button
                key={user.id}
                type="button"
                className="w-full text-left px-4 py-2.5 text-sm text-text hover:bg-gray5 transition-colors first:rounded-t-xl last:rounded-b-xl"
                onClick={() => handleSelect(user)}
              >
                {user?.person?.name} {user?.person?.lastname || ''}
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
};